// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { REMOVE_ORGANIZATION_MEMBERSHIP } from "./action";

export function canRemoveOrganizationMembership(scope: Scope): boolean {
  return scope.iamActions.includes(REMOVE_ORGANIZATION_MEMBERSHIP);
}
